<template>
  <v-container class="text-center">
    <h1>404 - Page Not Found</h1>
    <p>The page you are looking for does not exist.</p>
  </v-container>
</template>

<script setup lang="ts"></script>

<style></style>
